angular.module("app").directive("designerUseColorAcrossCategories", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbDesignerUseColorAcrossCategories/dbDesignerUseColorAcrossCategoriesView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
